import React, { useEffect, useState } from "react";
import ModalBasic from "../ModalBasic";
import _ from "lodash";
import { GetDataOptions } from "../../utils/Utils";
import Select from "react-select";
import Banner from "../Banner/Banner";

export default function ModalQR({
  showModal,
  setShowModal,
  modalQRDetails,
  inputQR,
  setInputQR,
  functionAdd,
  functionEdit,
  dataOutletKartini,
}) {
  // initial variabel for validation
  const [validationQR, setValidationQR] = useState({
    email: {
      validate: true,
      message: "",
    },
    phone: {
      validate: true,
      message: "",
    },
    general: {
      validate: true,
      message: "",
    },
  });

  const FilterData = [
    {
      url: `/v2/collection/project/data?length=0&channel_id=${dataOutletKartini.channel_id}&length=0`,
      label: "project_name",
      key: "project_id",
      name: "project",
    },
    {
      url: `/v2/collection/chat/questionTrigger/data?project_id=${inputQR.project_id}&is_public=1&length=0`,
      label: "alias",
      key: "chat_question_trigger_id",
      name: "hashtag",
    },
    {
      url: `/v2/collection/akuisisi/data?channel_id=${dataOutletKartini.channel_id}&length=0`,
      label: "user_name",
      key: "akuisisi_id",
      name: "User",
    },
  ];

  const [options, setOptions] = useState({});

  useEffect(() => {
    GetDataOptions(FilterData, setOptions);
    return () => {
      setOptions({});
    };
  }, [inputQR]);

  function handleChange(e) {
    setInputQR((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }

  return (
    <>
      {/* Modal ADD QR */}
      <ModalBasic
        name="add_outlet_modal"
        modalOpen={showModal}
        setModalOpen={setShowModal}
        title={modalQRDetails.title}
        enClose={true}
      >
        <div className="px-5 pt-4 pb-1">
          <div className="space-y-3">
            {/* PROJECT */}
            <div className="font-semibold text-gray-600 text-sm">Project</div>
            <Select
              className="col-span-full sm:col-span-2"
              placeholder="Project Name"
              options={options?.project_id?.data}
              value={options?.project_id?.data.filter(
                (option) => option.value === inputQR.project_id
              )}
              onChange={(e) =>
                setInputQR((prevState) => ({
                  ...prevState,
                  project_id: e.value,
                }))
              }
            />
            {/* HASHTAG */}
            <div className="font-semibold text-gray-600 text-sm">Hashtag</div>
            <Select
              className="col-span-full sm:col-span-2"
              placeholder="Hashtag Name"
              options={options?.chat_question_trigger_id?.data}
              value={options?.chat_question_trigger_id?.data.filter(
                (option) => option.value === inputQR.chat_question_trigger_id
              )}
              onChange={(e) =>
                setInputQR((prevState) => ({
                  ...prevState,
                  chat_question_trigger_id: e.value,
                  question_trigger: e.question_trigger,
                }))
              }
              isDisabled={_.isEmpty(inputQR.project_id)}
            />
            {/* USER */}
            <div className="font-semibold text-gray-600 text-sm">User</div>
            <Select
              className="col-span-full sm:col-span-2"
              placeholder="User Name"
              options={options?.akuisisi_id?.data}
              value={options?.akuisisi_id?.data.filter(
                (option) => option.value === inputQR.akuisisi_id
              )}
              onChange={(e) =>
                setInputQR((prevState) => ({
                  ...prevState,
                  akuisisi_id: e.value,
                }))
              }
              isDisabled={_.isEmpty(inputQR.chat_question_trigger_id)}
            />
            <Banner
              type="error"
              open={!validationQR.general.validate}
              enableClose={false}
            >
              {!validationQR.general.message}
            </Banner>
          </div>
        </div>
        {/* Modal footer */}
        <div className="px-5 py-4">
          <div className="flex flex-wrap justify-end space-x-2">
            <button
              className="btn-sm border-gray-200 hover:border-gray-300 text-gray-600"
              onClick={(e) => {
                e.stopPropagation();
                setShowModal(false);
                setInputQR({});
              }}
            >
              Close
            </button>
            <button
              className="btn-sm bg-[#4CA6F8] text-white disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
              onClick={(e) => {
                e.stopPropagation();
                if (modalQRDetails.type === "Add") {
                  functionAdd();
                } else if (modalQRDetails.type === "Edit") {
                  functionEdit(inputQR);
                }
              }}
              disabled={!inputQR.project_id || !inputQR.akuisisi_id}
            >
              {modalQRDetails.title}
            </button>
          </div>
        </div>
      </ModalBasic>
    </>
  );
}
